export default "__VITE_ASSET__DS3GL56u__"